require("./provider-type-multi-select-list.scss");

import {ChangeDetectionStrategy, Component, computed, input, output, signal} from "@angular/core";
import * as _ from "lodash";
import {THREE_PL_PROVIDER_TYPES} from "../../constants/threepl.constant";

@Component({
  selector: "app-provider-type-multi-select-list",
  templateUrl: "./provider-type-multi-select-list.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProviderTypeMultiSelectListComponent {
  readonly providerTypes = input<string[]>();
  readonly placeholder = input<string>();
  readonly providerTypesChange = output<string[]>();

  readonly query = signal("");

  readonly rows = computed(() => {
    const query = this.query().toLowerCase();
    const selected = new Set(this.providerTypes() ?? []);
    return THREE_PL_PROVIDER_TYPES
      .filter((option) => !query || option.toLowerCase().includes(query))
      .map((option) => ({option, checked: selected.has(option)}));
  });

  onToggle(option: string, isSelected: boolean): void {
    this.providerTypesChange.emit(isSelected
      ? _.concat(this.providerTypes(), [option])
      : _.filter(this.providerTypes(), (id) => id !== option));
  }
}
